module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recipe-slider",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "mouseenter": _vm.addHoverFocus,
      "mouseover": _vm.addHoverFocus,
      "mouseout": _vm.removeHoverFocus,
      "mouseleave": _vm.removeHoverFocus
    }
  }, [_c('mu-card', [_c('div', {
    staticClass: "title"
  }, [_c('mu-row', {
    staticStyle: {
      "align-items": "center"
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "50"
    }
  }, [_vm._m(0)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "50",
      "align": "right"
    }
  }, [_c('mu-content-block', {
    staticStyle: {
      "padding-top": "0px",
      "padding-bottom": "0"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "See all"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToGroupingCategory.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "owl-carousel horizontal-scroller scrolling-wrapper",
    attrs: {
      "id": 'scrolling-recipe-' + _vm.id
    }
  }, _vm._m(1), 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-content-block', {
    staticClass: "title",
    staticStyle: {
      "padding-top": "0px",
      "padding-bottom": "0"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.recipes), function(item, recipeI) {
    return _c('recipe-card', {
      key: 'recipe-' + recipeI + _vm._uid,
      attrs: {
        "recipe": item
      },
      nativeOn: {
        "mouseenter": function($event) {
          return _vm.addRecipeTween.apply(null, arguments)
        },
        "mouseleave": function($event) {
          return _vm.removeRecipeTween.apply(null, arguments)
        }
      }
    })
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-158985f5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Recipes/Components/HorizontalScroller.vue
// module id = 3059
// module chunks = 1